import React, { Fragment, useEffect } from "react";
import Backbar from "~/pages/NetworkProviders/BackBar";

import security from "~/services/security";

const TheoremReach = ({})=> {

  const apikey      = '2aa26933e25a387dad95cb2f3a8a';
  const currentUser = security.currentUserValue;
  const random      = Math.random().toString(36).substring(2, 15);

  useEffect(()=> {
    document.body.style.overflow = "hidden";
  }, []);

  return (
    <Fragment>
      <Backbar path="/surveys" showLogo={true} />

      <iframe
        width="100%"
        frameBorder="0"
        style={{height: "92vh"}}
        src={`https://theoremreach.com/respondent_entry/direct?api_key=${apikey}&user_id=${currentUser.id}&transaction_id=${currentUser.id}-${random}`}
      ></iframe>

    </Fragment>
  );
};

export default TheoremReach;
